import api from './api';

export const authService = {
  async login(email, password) {
    const response = await api.post('/api/auth/login', { email, password });
    const { access_token, user, organizations } = response.data;
    
    // Store token and user info
    localStorage.setItem('access_token', access_token);
    localStorage.setItem('user', JSON.stringify(user));
    
    // If user has organizations, set the first one as active
    if (organizations && organizations.length > 0) {
      localStorage.setItem('activeOrgId', organizations[0].id);
      localStorage.setItem('userRole', organizations[0].role);
    }
    
    return { user, organizations };
  },

  async signup(name, email, password) {
    const response = await api.post('/api/auth/signup', { name, email, password });
    const { access_token, user, requires_verification, email: signupEmail } = response.data;

    if (access_token && user) {
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('user', JSON.stringify(user));
      return { user };
    }

    return {
      requires_verification: !!requires_verification,
      email: signupEmail || email
    };
  },

  async verifyEmail(email, code) {
    const response = await api.post('/api/auth/verify-email', { email, code });
    const { access_token, user, organizations } = response.data;
    if (access_token) {
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('user', JSON.stringify(user));
      if (organizations && organizations.length > 0) {
        localStorage.setItem('activeOrgId', organizations[0].id);
        localStorage.setItem('userRole', organizations[0].role);
      }
    }
    return response.data;
  },

  async resendVerification(email) {
    const response = await api.post('/api/auth/resend-verification', { email });
    return response.data;
  },

  async logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    localStorage.removeItem('activeOrgId');
    localStorage.removeItem('userRole');
  },

  async getCurrentUser() {
    try {
      const response = await api.get('/api/auth/me');
      return response.data;
    } catch (error) {
      console.error('Get current user error:', error);
      return null;
    }
  },

  async updateProfile(profileData) {
    const response = await api.put('/api/auth/me', profileData);
    return response.data;
  },

  async getOrganizations() {
    const response = await api.get('/api/auth/organizations');
    return response.data;
  },

  async createOrganization(name, currency = 'INR', timezone = 'Asia/Kolkata') {
    const response = await api.post('/api/auth/organizations', { name, currency, timezone });
    return response.data;
  },

  async getTeamMembers(organizationId) {
    const response = await api.get('/api/auth/team-members', {
      params: { organization_id: organizationId }
    });
    return response.data;
  },

  async removeTeamMember(memberId, organizationId) {
    const response = await api.delete(`/api/auth/team-members/${memberId}`, {
      params: { organization_id: organizationId }
    });
    return response.data;
  },

  async getMemberWeddings(memberId, organizationId) {
    const response = await api.get(`/api/auth/team-members/${memberId}/weddings`, {
      params: { organization_id: organizationId }
    });
    return response.data;
  },

  async assignMemberToWeddings(memberId, organizationId, weddingIds) {
    const response = await api.post(
      `/api/auth/team-members/${memberId}/weddings?organization_id=${organizationId}`,
      weddingIds  // FastAPI will accept this as the request body for List[str]
    );
    return response.data;
  },

  async unassignMemberFromWedding(memberId, weddingId, organizationId) {
    const response = await api.delete(`/api/auth/team-members/${memberId}/weddings/${weddingId}`, {
      params: { organization_id: organizationId }
    });
    return response.data;
  },

  async updateTeamMember(memberId, organizationId, memberData) {
    const response = await api.put(`/api/auth/team-members/${memberId}`, memberData, {
      params: { organization_id: organizationId }
    });
    return response.data;
  },

  async updateMemberRole(memberId, organizationId, newRole) {
    const response = await api.patch(`/api/auth/team-members/${memberId}/role`, { new_role: newRole }, {
      params: { organization_id: organizationId }
    });
    return response.data;
  },

  async upgradeOrganization(organizationId, credits) {
    const response = await api.post(`/api/auth/organizations/${organizationId}/upgrade`, { credits });
    return response.data;
  },

  isAuthenticated() {
    return !!localStorage.getItem('access_token');
  },

  getStoredUser() {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }
};
